/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

export function CollapseIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 4.5C21 3.67157 20.3284 3 19.5 3H5.5C4.67157 3 4 3.67157 4 4.5V18.5C4 19.3284 4.67157 20 5.5 20H19.5C20.3284 20 21 19.3284 21 18.5V4.5ZM16.5 11C16.7761 11 17 11.2239 17 11.5C17 11.7761 16.7761 12 16.5 12H8.5C8.22386 12 8 11.7761 8 11.5C8 11.2239 8.22386 11 8.5 11H16.5ZM22 18.5C22 19.8807 20.8807 21 19.5 21H5.5C4.11929 21 3 19.8807 3 18.5V4.5C3 3.11929 4.11929 2 5.5 2H19.5C20.8807 2 22 3.11929 22 4.5V18.5Z"
        fill="#3A5C84"
      />
    </svg>
  );
}
